<script>
import { mapGetters } from 'vuex';

export default {
  name: 'OrganizationalUnitListItem',
  props: {
    organizationalUnit: {
      type: Object,
      required: true,
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapGetters('app', ['auth']),
  },
  methods: {
    onDelete() {
      this.$emit('delete', this.organizationalUnit);
    },
  },
};
</script>

<template>
  <tr>
    <td>
      <router-link :to="`/organizationalUnit/show/${organizationalUnit.id}`">
        {{ organizationalUnit.name }}
      </router-link>
    </td>
    <td>
      <v-icon v-if="organizationalUnit.isDelete">done</v-icon>
      <v-icon v-else>close</v-icon>
    </td>
    <td width="80" align="right">
      <v-tooltip bottom>
        <v-btn
          v-if="auth.hasDeleteRights"
          :disabled="organizationalUnit.isDelete"
          slot="activator"
          flat icon
          @click.native="onDelete"
        >
          <v-icon small>delete</v-icon>
        </v-btn>
        <span>Löschen</span>
      </v-tooltip>
    </td>
  </tr>
</template>
